import { Theme, BuilderBlockProps } from "@/types";
import { FC, ReactNode } from "react";

type SectionBlockProps = {
  children: ReactNode;
  theme: Theme;
} & BuilderBlockProps;
export const SectionBlock: FC<SectionBlockProps> = ({
  children,
  attributes,
  theme,
}) => (
  <section data-theme={theme} {...attributes}>
    {children}
  </section>
);
